/**
 * Error lanzado cuando se detecta que el usuario alteró manualmente
 * los datos persistidos. Captura el nombre de la clave afectada.
 *
 * NO se lanza en casos de data corrupta por versión vieja o JSON
 * malformado; solo cuando hay evidencia de edición manual (checksum
 * mismatch sobre un blob bien formado).
 */
export class TamperDetectedError extends Error {
  constructor(
    public readonly keyAfectada: string,
    public readonly detalle: string,
  ) {
    super(`Tamper detectado en "${keyAfectada}": ${detalle}`);
    this.name = 'TamperDetectedError';
    Object.setPrototypeOf(this, TamperDetectedError.prototype);
  }
}

export function esTamperError(err: unknown): err is TamperDetectedError {
  return err instanceof TamperDetectedError;
}
